import { useRef } from "react";
import Wrapper from "../../components/sectionWrapper";
import { useLangContext } from "../../components/translateContext";
import Messages from "./translations/index.json";
import "./index.css";

export default function TermsAndCondition() {
  const { Lang } = useLangContext();
  const Infos = Messages[Lang];

  const leftColumnRef = useRef(null);
  const scrollToTitle = (title) => {
    console.log("title:", title)
    const titleElement = document.getElementById(title);

    if ( title === "title1" || title === "title2"  ){
      titleElement.scrollIntoView(false);
    }else if (titleElement) {
      console.log("titleElement:", titleElement)
      titleElement.scrollIntoView({ behavior: "auto", block: "start", inline: "nearest" });
    
    }
  };

  return (
    <Wrapper childrenClassName="h-full rounded my-20 py-10">
      <h2 className="text-center my-10">{Infos.Title}</h2>
      <div className="flex justify-center mx-auto w-full my-14 mb-20">
        <div>
          <h3 className="md:text-Mobilp text-opacity-70 py-2">
            {Infos.last}
          </h3>
          <p className="md:text-Mobilp  ">
          {Infos.this}
            <br />
          </p>
        </div>
      </div>

      <div className="flex w-full ">
        <div className=" w-5/12" ref={leftColumnRef}>
          <div className="flex-col flex gap-8">
            <h3 onClick={() => scrollToTitle('title1')} className='text-Nw clickable-title'>Introduction</h3>
            <p  onClick={() => scrollToTitle('title2')}className='text-Nw clickable-title'>{Infos.Title_Definitions}</p>
            <p onClick={() => scrollToTitle('title3')} className='text-Nw clickable-title'>{Infos.Title_GeneralTerms}</p>
            <p onClick={() => scrollToTitle('title4')} className='text-Nw clickable-title'>{Infos.Title_Nonexclusivity}</p>
            <p  onClick={() => scrollToTitle('title5')} className='text-Nw clickable-title'>{Infos.Title_DataSecurity}</p>
            <p onClick={() => scrollToTitle('title6')} className='text-Nw clickable-title'>{Infos.Title_Term}</p>
            <p onClick={() => scrollToTitle('title7')} className='text-Nw clickable-title'>{Infos.Title_QOSObligations}</p>
            <p onClick={() => scrollToTitle('title8')} className='text-Nw clickable-title'>{Infos.Title_TheMerchantObligations}</p>
            <p onClick={() => scrollToTitle('title9')} className='text-Nw clickable-title'>{Infos.Title_ChargebacksAndRefunds}</p>
            <p onClick={() => scrollToTitle('title10')} className='text-Nw clickable-title'>{Infos.Title_SetOff}</p>
            <p onClick={() => scrollToTitle('title11')} className='text-Nw clickable-title'>{Infos.Title_Fees}</p>
            <p onClick={() => scrollToTitle('title12')} className='text-Nw clickable-title'>{Infos.Title_Warranties}</p>
            <p onClick={() => scrollToTitle('title13')} className='text-Nw clickable-title'>{Infos.Title_Indemnity}</p>
            <p onClick={() => scrollToTitle('title14')} className='text-Nw clickable-title'>{Infos.Title_FraudulentTransactions}</p>
            <p onClick={() => scrollToTitle('title15')} className='text-Nw clickable-title'>{Infos.Title_RollingReserve}</p>
            <p onClick={() => scrollToTitle('title16')} className='text-Nw clickable-title'>{Infos.Title_SecurityDeposit}</p>
            <p onClick={() => scrollToTitle('title17')} className='text-Nw clickable-title'>{Infos.Title_LimitationOfLiability}</p>
            <p onClick={() => scrollToTitle('title18')} className='text-Nw clickable-title'>{Infos.Title_Termination}</p>
            <p onClick={() => scrollToTitle('title19')} className='text-Nw clickable-title'>{Infos.Title_Confidentiality}</p>
            <p onClick={() => scrollToTitle('title20')} className='text-Nw clickable-title'>{Infos.Title_ForceMajeure}</p>
            <p onClick={() => scrollToTitle('title21')} className='text-Nw clickable-title'>{Infos.Title_RelationshipBetweenParties}</p>
            <p onClick={() => scrollToTitle('title22')} className='text-Nw clickable-title'>{Infos.Title_IntellectualProperty}</p>
            <p onClick={() => scrollToTitle('title23')} className='text-Nw clickable-title'>{Infos.Title_Modifications}</p>
            <p onClick={() => scrollToTitle('title24')} className='text-Nw clickable-title'>{Infos.Title_Waiver}</p>
            <p onClick={() => scrollToTitle('title25')} className='text-Nw clickable-title'>{Infos.Title_Severance}</p>
            <p onClick={() => scrollToTitle('title26')} className='text-Nw clickable-title'>{Infos.Title_WholeAgreement}</p>
            <p onClick={() => scrollToTitle('title27')} className='text-Nw clickable-title'>{Infos.Title_DisputesAndDisputeResolution}</p>
            <p onClick={() => scrollToTitle('title28')} className='text-Nw clickable-title'>{Infos.Title_FurtherAssurances}</p>
            <p onClick={() => scrollToTitle('title29')} className='text-Nw clickable-title'>{Infos.Title_Notices}</p>
            <p onClick={() => scrollToTitle('title30')} className='text-Nw clickable-title'>{Infos.Title_AntiCorruption}</p>
          </div>
        </div>
        <div className="w-7/12 ">
          <h3 id="title1" className="md:mb-2 md:mt-0 my-4">{Infos.Title_Introduction}</h3>
          <p className="md:text-Mobilp  py-2">
            {Infos.Para_Introduction1.toLowerCase()}
          </p>
          <br />
          <p className="md:text-Mobilp  py-2">
            {Infos.Para_Introduction2.toLowerCase()}
          </p>
          <br />
          <p className="md:text-Mobilp  py-2">
            {Infos.Para_Introduction3.toLowerCase()}
          </p>
          <br />
          <p className="md:text-Mobilp  py-2">
            {Infos.Para_Introduction4.toLowerCase()}
          </p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Introduction5}</p>
          <br />
          <p>
            <ol style={{ paddingLeft: "10px" }}>
              <li className="md:text-Mobilp  py-2">
                1. {Infos.Sous_Para_IntroductionA}
              </li>
              <li className="md:text-Mobilp  py-2">
                2. {Infos.Sous_Para_IntroductionB}
              </li>
              <li className="md:text-Mobilp  py-2">
                3. {Infos.Sous_Para_IntroductionC}
              </li>
              <li className="md:text-Mobilp  py-2">
                4.{Infos.Sous_Para_IntroductionD}
              </li>
            </ol>
          </p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Introduction6}</p>

          <h3 className="md:mb-2 md:mt-4 my-4">1. {Infos.Title_Definitions}</h3>
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions1}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions2}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions3}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions4}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions5}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions6}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions7}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions8}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions9}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions10}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions11}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions12}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions13}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions14}</p>
          <br />
          <ul style={{ paddingLeft: "10px" }}>
            <p className="md:text-Mobilp  py-2">
              a. {Infos.Para_Definitions14A}
            </p>

            <li className="md:text-Mobilp  py-2">
              b. {Infos.Para_Definitions14B}
            </li>

            <ol style={{ paddingLeft: "10px" }}>
              <li className="md:text-Mobilp  py-2">
                1. {Infos.Para_Definitions14B1}
              </li>
              <li className="md:text-Mobilp  py-2">
                2. {Infos.Para_Definitions14B2}
              </li>
              <li className="md:text-Mobilp  py-2">
                3. {Infos.Para_Definitions14B3}
              </li>
            </ol>

            <p className="md:text-Mobilp  py-2">
              c. {Infos.Para_Definitions14C}
            </p>
            <li className="md:text-Mobilp  py-2">
              d. {Infos.Para_Definitions14D}
            </li>
          </ul>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions15}</p>
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions16}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions17}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions18}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions19}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions20}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions21}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions22}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions23}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions24}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions25}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions26}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions27}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions28}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions29}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions30}</p>
          <br />
          <p className="md:text-Mobilp  py-2">{Infos.Para_Definitions31}</p>

          <h3 id="title2" className="md:mb-2 md:mt-4 my-4">
            2. {Infos.Title_GeneralTerms}
          </h3>
          <p className="md:text-Mobilp  py-2">{Infos.Para_GeneralTerms}</p>
          <br />
          <ul style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms1}
            </li>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms2}
            </li>
            <ol style={{ paddingLeft: "10px" }}>
              <li className="md:text-Mobilp  py-2">
                {Infos.Point_GeneralTerms2_1}
              </li>
              <li className="md:text-Mobilp  py-2">
                {Infos.Point_GeneralTerms2_2}
              </li>
            </ol>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms3}
            </li>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms4}
            </li>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms5}
            </li>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms6}
            </li>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms7}
            </li>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms8}
            </li>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms9}
            </li>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms10}
            </li>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms11}
            </li>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms12}
            </li>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms13}
            </li>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms14}
            </li>
            <li className="md:text-Mobilp  py-2">
              &#9632; {Infos.Point_GeneralTerms15}
            </li>
          </ul>
          <h3 id="title3" className="md:mb-2 md:mt-4 my-4">
            3. {Infos.Title_Nonexclusivity}
          </h3>
          <p className="md:text-Mobilp  py-2">{Infos.Para_Nonexclusivity}</p>
          <h3 id="title4" className="md:mb-2 md:mt-4 my-4">
            4. {Infos.Title_DataSecurity}
          </h3>
          <p className="md:text-Mobilp  py-2">{Infos.Para_DataSecurity}</p>
          <h3 id="title5" className="md:mb-2 md:mt-4 my-4">5. {Infos.Title_Term}</h3>
          <p className="md:text-Mobilp  py-2">
            {Infos.Para_Term1}
            {Infos.Para_Term2}
          </p>
          <h3 id="title6" className="md:mb-2 md:mt-4 my-4">
            6. {Infos.Title_QOSObligations}
          </h3>
          <p className="md:text-Mobilp  py-2">{Infos.Para_QOSObligations}</p>
          <br />
          <ul style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">1. {Infos.QOSObligations1}</li>
            <li className="md:text-Mobilp  py-2">2. {Infos.QOSObligations2}</li>
            <li className="md:text-Mobilp  py-2">3. {Infos.QOSObligations3}</li>
            <li className="md:text-Mobilp  py-2">4. {Infos.QOSObligations4}</li>
            <li className="md:text-Mobilp  py-2">5. {Infos.QOSObligations5}</li>
            <li className="md:text-Mobilp  py-2">6. {Infos.QOSObligations6}</li>
            <li className="md:text-Mobilp  py-2">7. {Infos.QOSObligations7}</li>
            <li className="md:text-Mobilp  py-2">8. {Infos.QOSObligations8}</li>
            <li className="md:text-Mobilp  py-2">9. {Infos.QOSObligations9}</li>
            <li className="md:text-Mobilp  py-2">
              10. {Infos.QOSObligations10}
            </li>
            <li className="md:text-Mobilp  py-2">
              11. {Infos.QOSObligations11}
            </li>
            <li className="md:text-Mobilp  py-2">
              12. {Infos.QOSObligations12}
            </li>
          </ul>

          <h3 id="title7" className="md:mb-2 md:mt-4 my-4">
            7. {Infos.Title_TheMerchantObligations}
          </h3>
          <p className="md:text-Mobilp  py-2">
            7.1 {Infos.Para_TheMerchantObligations1}
          </p>
          <br />

          <ul style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">
              1. {Infos.TheMerchantObligations1}
            </li>
            <li className="md:text-Mobilp  py-2">
              2. {Infos.TheMerchantObligations2}
            </li>
            <li className="md:text-Mobilp  py-2">
              3. {Infos.TheMerchantObligations3}
            </li>
            <li className="md:text-Mobilp  py-2">
              4. {Infos.TheMerchantObligations4}
            </li>
            <li className="md:text-Mobilp  py-2">
              5. {Infos.TheMerchantObligations5}
            </li>
            <li className="md:text-Mobilp  py-2">
              6. {Infos.TheMerchantObligations6}
            </li>
            <li className="md:text-Mobilp  py-2">
              7. {Infos.TheMerchantObligations7}
            </li>
            <li className="md:text-Mobilp  py-2">
              8. {Infos.TheMerchantObligations8}
            </li>
            <li className="md:text-Mobilp  py-2">
              9. {Infos.TheMerchantObligations9}
            </li>
            <li className="md:text-Mobilp  py-2">
              10. {Infos.TheMerchantObligations10}
            </li>
            <li className="md:text-Mobilp  py-2">
              11. {Infos.TheMerchantObligations11}
            </li>
            <li className="md:text-Mobilp  py-2">
              12. {Infos.TheMerchantObligations12}
            </li>
            <li className="md:text-Mobilp  py-2">
              13. {Infos.TheMerchantObligations13}
            </li>
            <li className="md:text-Mobilp  py-2">
              14. {Infos.TheMerchantObligations14}
            </li>
            <li className="md:text-Mobilp  py-2">
              15. {Infos.TheMerchantObligations15}
            </li>

            <ul style={{ paddingLeft: "30px" }}>
              <li className="md:text-Mobilp  py-2">
                1. {Infos.TheMerchantObligations151}
              </li>
              <li className="md:text-Mobilp  py-2">
                2. {Infos.TheMerchantObligations152}
              </li>
              <li className="md:text-Mobilp  py-2">
                3. {Infos.TheMerchantObligations153}
              </li>
              <li className="md:text-Mobilp  py-2">
                4. {Infos.TheMerchantObligations154}
              </li>
              <li className="md:text-Mobilp  py-2">
                5. {Infos.TheMerchantObligations155}
              </li>
              <li className="md:text-Mobilp  py-2">
                6. {Infos.TheMerchantObligations156}
              </li>
              <li className="md:text-Mobilp  py-2">
                {Infos.TheMerchantObligations157}
              </li>
            </ul>

            <li className="md:text-Mobilp  py-2">
              16. {Infos.TheMerchantObligations16}
            </li>
            <li className="md:text-Mobilp  py-2">
              17. {Infos.TheMerchantObligations17}
            </li>
            <li className="md:text-Mobilp  py-2">
              18. {Infos.TheMerchantObligations18}
            </li>
            <li className="md:text-Mobilp  py-2">
              19. {Infos.TheMerchantObligations19}
            </li>
            <li className="md:text-Mobilp  py-2">
              20. {Infos.TheMerchantObligations20}
            </li>
            <li className="md:text-Mobilp  py-2">
              21. {Infos.TheMerchantObligations21}
            </li>
            <li className="md:text-Mobilp  py-2">
              22. {Infos.TheMerchantObligations22}
            </li>
            <li className="md:text-Mobilp  py-2">
              23. {Infos.TheMerchantObligations23}
            </li>
            <li className="md:text-Mobilp  py-2">
              24. {Infos.TheMerchantObligations24}
            </li>
            <li className="md:text-Mobilp  py-2">
              25. {Infos.TheMerchantObligations25}
            </li>
            <li className="md:text-Mobilp  py-2">
              26. {Infos.TheMerchantObligations26}
            </li>
          </ul>
          <br />

          <p className="md:text-Mobilp  py-2">
            7.2 {Infos.Para_TheMerchantObligations2}
          </p>
          <p className="md:text-Mobilp  py-2">
            7.3 {Infos.Para_TheMerchantObligations3}
          </p>
          <p className="md:text-Mobilp  py-2">
            7.4 {Infos.Para_TheMerchantObligations4}
          </p>
          <h3 id="title8" className="md:mb-2 md:mt-4 my-4">
            8. {Infos.Title_ChargebacksAndRefunds}
          </h3>

          <ul style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">
              1. {Infos.ChargebacksAndRefunds1}
            </li>
            <li className="md:text-Mobilp  py-2">
              2. {Infos.ChargebacksAndRefunds2}
            </li>
            <li className="md:text-Mobilp  py-2">
              3. {Infos.ChargebacksAndRefunds3}
            </li>
            <li className="md:text-Mobilp  py-2">
              4. {Infos.ChargebacksAndRefunds4}
            </li>
            <li className="md:text-Mobilp  py-2">
              5. {Infos.ChargebacksAndRefunds5}
            </li>
            <br />
            <ul style={{ paddingLeft: "30px" }}>
              <li className="md:text-Mobilp  py-2">
                1. {Infos.ChargebacksAndRefunds51}
              </li>
              <li className="md:text-Mobilp  py-2">
                2. {Infos.ChargebacksAndRefunds52}
              </li>
            </ul>
            <br />
            <li className="md:text-Mobilp  py-2">
              6. {Infos.ChargebacksAndRefunds6}
            </li>
            <li className="md:text-Mobilp  py-2">
              7. {Infos.ChargebacksAndRefunds7}
            </li>
            <li className="md:text-Mobilp  py-2">
              8. {Infos.ChargebacksAndRefunds8}
            </li>
            <li className="md:text-Mobilp  py-2">
              9. {Infos.ChargebacksAndRefunds9}
            </li>
            <li className="md:text-Mobilp  py-2">
              10. {Infos.ChargebacksAndRefunds10}
            </li>
          </ul>

          <h3 id="title9" className="md:mb-2 md:mt-4 my-4">9. {Infos.Title_SetOff}</h3>
          <ul style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">1. {Infos.SetOff1}</li>
            <li className="md:text-Mobilp  py-2">2. {Infos.SetOff2}</li>
            <li className="md:text-Mobilp  py-2">3. {Infos.SetOff3}</li>
            <li className="md:text-Mobilp  py-2">4. {Infos.SetOff4}</li>
          </ul>
          <h3 id="title10" className="md:mb-2 md:mt-4 my-4">10. {Infos.Title_Fees}</h3>
          <ul style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">1. {Infos.Fees1}</li>
            <li className="md:text-Mobilp  py-2">2. {Infos.Fees2}</li>
            <li className="md:text-Mobilp  py-2">3. {Infos.Fees3}</li>
            <li className="md:text-Mobilp  py-2">4. {Infos.Fees4}</li>

            <ul style={{ paddingLeft: "30px" }}>
              <li className="md:text-Mobilp  py-2">1. {Infos.Fees41}</li>
              <li className="md:text-Mobilp  py-2">2. {Infos.Fees42}</li>
              <li className="md:text-Mobilp  py-2">3. {Infos.Fees43}</li>
            </ul>

            <li className="md:text-Mobilp  py-2">5. {Infos.Fees5}</li>
            <li className="md:text-Mobilp  py-2">6. {Infos.Fees6}</li>
          </ul>
          <h3 id="title11" className="md:mb-2 md:mt-4 my-4">11. {Infos.Title_Warranties}</h3>
          <ul style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">1. {Infos.Warranties1}</li>
            <li className="md:text-Mobilp  py-2">2. {Infos.Warranties2}</li>
            <li className="md:text-Mobilp  py-2">3. {Infos.Warranties3}</li>
            <li className="md:text-Mobilp  py-2">4. {Infos.Warranties4}</li>
            <li className="md:text-Mobilp  py-2">5. {Infos.Warranties5}</li>
            <li className="md:text-Mobilp  py-2">6. {Infos.Warranties6}</li>
            <br />
            <ul style={{ paddingLeft: "30px" }}>
              <li className="md:text-Mobilp  py-2">1. {Infos.Warranties61}</li>
              <li className="md:text-Mobilp  py-2">2. {Infos.Warranties62}</li>
              <li className="md:text-Mobilp  py-2">4. {Infos.Warranties63}</li>
              <li className="md:text-Mobilp  py-2">5. {Infos.Warranties64}</li>
            </ul>
            <br />

            <li className="md:text-Mobilp  py-2">7. {Infos.Warranties7}</li>
            <li className="md:text-Mobilp  py-2">8. {Infos.Warranties8}</li>
            <li className="md:text-Mobilp  py-2">9. {Infos.Warranties9}</li>
            <li className="md:text-Mobilp  py-2">10. {Infos.Warranties10}</li>
            <li className="md:text-Mobilp  py-2">11. {Infos.Warranties11}</li>
            <li className="md:text-Mobilp  py-2">12. {Infos.Warranties12}</li>
            <li className="md:text-Mobilp  py-2">13. {Infos.Warranties13}</li>
            <li className="md:text-Mobilp  py-2">
              14. {Infos.Warranties14.toLowerCase()}
            </li>
          </ul>

          <h3 id="title12" className="md:mb-2 md:mt-4 my-4">12. {Infos.Title_Indemnity}</h3>
          <p className="md:text-Mobilp  py-2">12.1 {Infos.Para_Indemnity1}</p>
          <br />
          <ul style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">1. {Infos.Indemnity11}</li>
            <li className="md:text-Mobilp  py-2">2. {Infos.Indemnity12}</li>
            <li className="md:text-Mobilp  py-2">3. {Infos.Indemnity13}</li>
          </ul>
          <br />
          <p className="md:text-Mobilp  py-2">12.2 {Infos.Para_Indemnity2}</p>
          <ul style={{ paddingLeft: "10px" }}>
            <br />
            <li className="md:text-Mobilp  py-2">1. {Infos.Indemnity21}</li>
            <li className="md:text-Mobilp  py-2">2. {Infos.Indemnity22}</li>
            <li className="md:text-Mobilp  py-2">3. {Infos.Indemnity23}</li>
            <li className="md:text-Mobilp  py-2">4. {Infos.Indemnity24}</li>
            <li className="md:text-Mobilp  py-2">5. {Infos.Indemnity25}</li>
            <li className="md:text-Mobilp  py-2">6. {Infos.Indemnity26}</li>
            <li className="md:text-Mobilp  py-2">7. {Infos.Indemnity27}</li>
            <li className="md:text-Mobilp  py-2">8. {Infos.Indemnity28}</li>
          </ul>
          <h3 id="title13" className="md:mb-2 md:mt-4 my-4">
            13. {Infos.Title_FraudulentTransactions}
          </h3>
          <p className="md:text-Mobilp  py-2">
            1. {Infos.Para_FraudulentTransactions1}
          </p>
          <ul style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">
              1. {Infos.FraudulentTransactions11}
            </li>
            <li className="md:text-Mobilp  py-2">
              2. {Infos.FraudulentTransactions12}
            </li>
          </ul>
          <br />
          <p className="md:text-Mobilp  py-2">
            2. {Infos.Para_FraudulentTransactions2}
          </p>
          <p className="md:text-Mobilp  py-2">
            3. {Infos.Para_FraudulentTransactions3}
          </p>
          <br />
          <ul style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">
              1. {Infos.FraudulentTransactions21}
            </li>
            <li className="md:text-Mobilp  py-2">
              2. {Infos.FraudulentTransactions22}
            </li>
            <li className="md:text-Mobilp  py-2">
              3. {Infos.FraudulentTransactions23}
            </li>
          </ul>
          <h3 id="title14" className="md:mb-2 md:mt-4 my-4">
            14. {Infos.Title_RollingReserve}
          </h3>
          <ol style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">1. {Infos.RollingReserve1}</li>
            <li className="md:text-Mobilp  py-2">2. {Infos.RollingReserve2}</li>
            <li className="md:text-Mobilp  py-2">3. {Infos.RollingReserve3}</li>
            <li className="md:text-Mobilp  py-2">4. {Infos.RollingReserve4}</li>
            <li className="md:text-Mobilp  py-2">5. {Infos.RollingReserve5}</li>
            <li className="md:text-Mobilp  py-2">6. {Infos.RollingReserve6}</li>
            <li className="md:text-Mobilp  py-2">7. {Infos.RollingReserve7}</li>
          </ol>
          <h3 id="title15" className="md:mb-2 md:mt-4 my-4">
            15. {Infos.Title_SecurityDeposit}
          </h3>
          <ol style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">
              1. {Infos.SecurityDeposit1}
            </li>
            <li className="md:text-Mobilp  py-2">
              2. {Infos.SecurityDeposit2}
            </li>
            <li className="md:text-Mobilp  py-2">
              3. {Infos.SecurityDeposit3}
            </li>
          </ol>
          <h3 id="title16" className="md:mb-2 md:mt-4 my-4">
            16. {Infos.Title_LimitationOfLiability}
          </h3>
          <p className="md:text-Mobilp  py-2">
            1. {Infos.Para_LimitationOfLiability}
          </p>
          <ol style={{ paddingLeft: "30px" }}>
            <li className="md:text-Mobilp  py-2">
              1. {Infos.LimitationOfLiability1}
            </li>
            <li className="md:text-Mobilp  py-2">
              2. {Infos.LimitationOfLiability2}
            </li>
            <li className="md:text-Mobilp  py-2">
              3.{Infos.LimitationOfLiability3}
            </li>
          </ol>
          <h3 id="title17" className="md:mb-2 md:mt-4 my-4">
            17. {Infos.Title_Termination}
          </h3>
          <p className="md:text-Mobilp  py-2">1 {Infos.Para_Termination1}</p>
          <ol style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">1. {Infos.Termination11}</li>
            <li className="md:text-Mobilp  py-2">2. {Infos.Termination12}</li>
          </ol>
          <p className="md:text-Mobilp  py-2">2. {Infos.Para_Termination2}</p>
          <p className="md:text-Mobilp  py-2">3. {Infos.Para_Termination3}</p>
          <p className="md:text-Mobilp  py-2">4. {Infos.Para_Termination4}</p>
          <p className="md:text-Mobilp  py-2">5. {Infos.Para_Termination5}</p>
          <p className="md:text-Mobilp  py-2">6. {Infos.Para_Termination6}</p>
          <p className="md:text-Mobilp  py-2">7. {Infos.Para_Termination7}</p>
          <h3 id="title18" className="md:mb-2 md:mt-4 my-4">
            18. {Infos.Title_Confidentiality}
          </h3>
          <ol style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">
              1. {Infos.Para_Confidentiality1}
            </li>
            <li className="md:text-Mobilp  py-2">
              2. {Infos.Para_Confidentiality2}
            </li>
            <li className="md:text-Mobilp  py-2">
              3. {Infos.Para_Confidentiality3}
            </li>
            <li className="md:text-Mobilp  py-2">
              4. {Infos.Para_Confidentiality4}
            </li>
            <li className="md:text-Mobilp  py-2">
              5. {Infos.Para_Confidentiality5}
            </li>
          </ol>
          <h3 id="title19" className="md:mb-2 md:mt-4 my-4">
            19. {Infos.Title_ForceMajeure}
          </h3>
          <ol style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">
              1. {Infos.Para_ForceMajeure1}
            </li>
            <li className="md:text-Mobilp  py-2">
              2. {Infos.Para_ForceMajeure2}
            </li>
          </ol>
          <h3 id="title20" className="md:mb-2 md:mt-4 my-4">
            20. {Infos.Title_RelationshipBetweenParties}
          </h3>
          <ol style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">
              1. {Infos.Para_RelationshipBetweenParties1}
            </li>
            <li className="md:text-Mobilp  py-2">
              2. {Infos.Para_RelationshipBetweenParties2}
            </li>
            <li className="md:text-Mobilp  py-2">
              3. {Infos.Para_RelationshipBetweenParties3}
            </li>
          </ol>
          <h3 id="title21" className="md:mb-2 md:mt-4 my-4">
            21. {Infos.Title_IntellectualProperty}
          </h3>
          <ol style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">
              1. {Infos.Para_IntellectualProperty1}
            </li>
            <li className="md:text-Mobilp  py-2">
              2. {Infos.Para_IntellectualProperty2}
            </li>
          </ol>
          <h3 id="title22" className="md:mb-2 md:mt-4 my-4">
            22. {Infos.Title_NoAssignment}
          </h3>
          <ol style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">
              1. {Infos.Para_NoAssignment1}
            </li>
            <li className="md:text-Mobilp  py-2">
              2. {Infos.Para_NoAssignment2}
            </li>
          </ol>
          <h3 id="title23" className="md:mb-2 md:mt-4 my-4">
            23. {Infos.Title_Modifications}
          </h3>
          <p className="md:text-Mobilp  py-2">{Infos.Para_Modifications}</p>
          <h3 id="title24" className="md:mb-2 md:mt-4 my-4">24. {Infos.Title_Waiver}</h3>
          <p className="md:text-Mobilp  py-2">{Infos.Para_Waiver}</p>
          <h3 id="title25" className="md:mb-2 md:mt-4 my-4">25. {Infos.Title_Severance}</h3>
          <p className="md:text-Mobilp  py-2">{Infos.Title_Severance}</p>
          <h3 id="title26" className="md:mb-2 md:mt-4 my-4">
            26. {Infos.Title_FurtherAssurances}
          </h3>
          <p className="md:text-Mobilp  py-2">
            {Infos.Title_FurtherAssurances}
          </p>
          <h3 id="title27" className="md:mb-2 md:mt-4 my-4">
            27. {Infos.Title_WholeAgreement}
          </h3>
          <p className="md:text-Mobilp  py-2">{Infos.Para_WholeAgreement}</p>
          <h3 id="title28" className="md:mb-2 md:mt-4 my-4">
            28. {Infos.Title_DisputesAndDisputeResolution}
          </h3>
          <ol style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">
              1. {Infos.Para_DisputesAndDisputeResolution1}
            </li>
            <li className="md:text-Mobilp  py-2">
              2. {Infos.Para_DisputesAndDisputeResolution2}
            </li>
            <li className="md:text-Mobilp  py-2">
              3. {Infos.Para_DisputesAndDisputeResolution3}
            </li>
            <li className="md:text-Mobilp  py-2">
              4. {Infos.Para_DisputesAndDisputeResolution4}
            </li>
            <li className="md:text-Mobilp  py-2">
              5. {Infos.Para_DisputesAndDisputeResolution5}
            </li>
          </ol>
          <h3 id="title29" className="md:mb-2 md:mt-4 my-4">
            29. {Infos.Title_FurtherAssurances2}
          </h3>
          <p className="md:text-Mobilp  py-2">
            {Infos.Para_FurtherAssurances2}
          </p>
          <h3 id="title30" className="md:mb-2 md:mt-4 my-4">30. {Infos.Title_Notices}</h3>
          <p className="md:text-Mobilp  py-2">1. {Infos.Para_Notices1}</p>
          <ol style={{ fontWeight: "bold", paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">{Infos.Notices1}</li>
            <li className="md:text-Mobilp  py-2">{Infos.Notices2}</li>
            <li className="md:text-Mobilp  py-2">{Infos.Notices3}</li>
            <li className="md:text-Mobilp  py-2">{Infos.Notices4}</li>
          </ol>
          <h3 id="title31" className="md:mb-2 md:mt-4 my-4">
            31. {Infos.Title_AntiCorruption}
          </h3>
          <ol style={{ paddingLeft: "10px" }}>
            <li className="md:text-Mobilp  py-2">
              1. {Infos.Para_AntiCorruption1}
            </li>
            <li className="md:text-Mobilp  py-2">
              2. {Infos.Para_AntiCorruption2}
            </li>
            <li className="md:text-Mobilp  py-2">
              3. {Infos.Para_AntiCorruption3}
            </li>
          </ol>
          <p className="md:text-Mobilp  py-2">{Infos.Para_Fin}</p>
        </div>
      </div>
    </Wrapper>
  );
}
